module.exports = __webpack_public_path__ + "img/CS0040_default_F0.018bc1bd.png";